// Route configuration
export const ROUTES = {
  HOME: '/',
  INTRODUCTION: '/',
  PROJECTS: '/projects',
  HACKATHON: '/hackathon',
  TEACHING: '/teaching',
  SKILLS: '/skills',
  CONTACT: '/contact',
};

// Navigation items configuration
export const NAV_ITEMS = [
  { path: ROUTES.INTRODUCTION, label: 'Introduction' },
  { path: ROUTES.SKILLS, label: 'Skills' },
  { path: ROUTES.PROJECTS, label: 'Projects' },
  { path: ROUTES.HACKATHON, label: 'Hackathon' },
  { path: ROUTES.TEACHING, label: 'Teaching' },
  { path: ROUTES.CONTACT, label: 'Contact' },
];
